<template>
    <div class="course-item flex-v">
        <div class="course-title flex" @click="loadMenu">
            <img class="conver" :src="baseApi+course.imgurl" alt="">
            <div class="flex-v flex-1 course-name">
                <div class="name">{{course.name}}</div>
                <div class="flex flex-pack-justify hours">
                    <div>{{course.coursehours}}课时</div>
                    <img class="more" src="../assets/img/icon_more.png">
                </div>
            </div>
        </div>
        <div class="menu-item flex flex-v" v-if="course.open">
            <div class="flex flex-align-center menu" v-for='menu in course.menus' :key='menu.id' >
                <div class="flex-1" @click="play(menu)">
                    <img src="../assets/img/icon_circle.png"/>
                    <span :class="playid==menu.id?'play':''">{{menu.title}}</span>
                </div>
                <div class="jy">
<!--                    <a  v-if="menu.handout"  :href="baseApi+menu.handout" target="_blank"><img src="../assets/img/icon_jy_red.png"></a>-->
                  <a  v-if="menu.handout"  :href="baseApi+menu.handout" target="_blank" style="font-size: 12px">讲义<br>下载</a>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

export default {
    name:"course-menu",
     props: {
        course: {
            type: Object,
            required: true,
            default: () => {}
        },
        playid:{
            type:Number,
            required: true,
            default: 0
        },
        index:{
            type:Number,
            required: true,
            default: 0
        }
    },
    methods: {
      play(menu) {
          this.$emit('play', menu,this.course)
      },
      loadMenu(){
          this.$emit('open', this.course,this.index)
      }
    },
    data(){
        return {
            baseApi:this.$baseApi,
        }
    }
}
</script>
<style lang="less">
.course-item{
    background-color: #3a3a3a;
    margin-top: 1px;
    .course-title{
        margin-right: 10px;
        font-size: 16px;
        height: 105px;
        font-family: '微软雅黑,PingFangSC-Regular';
        .conver{
            height: 80px;
            width: 63px;
            margin: auto 10px;
        }
        .course-name{
            padding-top:10px ;
            color: #ffffff;
            .hours{
                padding-top:25px;
                font-size: 12px;
                color: #818181;
            }
            .more{
                height: 15px;
            }
        }

    }

    .menu-item{
        background-color: #1d1d1d;
        font-size: 14px;
        color: #8e8a8a;
        margin: 5px 0px;
        .menu{
            margin: 5px 20px;
        }
        img{
            margin-right: 10px;
            width: 10px;
            height: 10px;
        }
        .play{
            color: #c51724;
        }
        .jy{
            width: 24px;
          a{
            color: #ababab;
          }
        }
    }
}

</style>



// WEBPACK FOOTER //
// src/components/CourseMenu.vue